var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-element"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('sup',[_vm._v("*")]):_vm._e()])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }